/**
 * Simple data cache service for read-only data hydration
 * Used for data that is fetched once and doesn't need offline sync or mutations
 */
export class SimpleDataCacheService<T> {
    private items: T[];

    constructor(initialItems: T[], private sortFn: (items: T[]) => T[]) {
        this.items = sortFn(initialItems);
    }

    setNewItems(items: T[]) {
        this.items = this.sortFn(items);
    }

    getItems(): T[] {
        return this.items;
    }
}
